import type { NoiseSuppressionNode, NoiseSuppressorParams } from '../../../../../types/streamEffects';
import NoiseSuppressionAudioWorkletNode from './NoiseSuppressionAudioWorkletNode';
import NoiseSuppressionScriptProcessor from './NoiseSuppressionScriptProcessorNode';
import { isSafari } from '../../../../../helpers/browser';

export default class NoiseSuppressionNodeProvider {
  readonly #context: AudioContext;

  readonly #noiseSuppressor: WebAssembly.WebAssemblyInstantiatedSource;

  #noiseSuppressionNode?: NoiseSuppressionAudioWorkletNode | NoiseSuppressionScriptProcessor;

  constructor({ context, noiseSuppressor }: NoiseSuppressorParams) {
    this.#context = context;
    this.#noiseSuppressor = noiseSuppressor;
  }

  async createNoiseSuppressionNode(): Promise<NoiseSuppressionNode> {
    return isSafari() ? this.createScriptProcessorNode() : await this.createAudioWorkletNode();
  }

  stop(): void {
    this.#noiseSuppressionNode?.update(false);
  }

  private async createAudioWorkletNode(): Promise<NoiseSuppressionAudioWorkletNode> {
    await NoiseSuppressionAudioWorkletNode.register(this.#context);
    this.#noiseSuppressionNode = new NoiseSuppressionAudioWorkletNode({
      context: this.#context,
      noiseSuppressor: this.#noiseSuppressor,
    });

    return this.#noiseSuppressionNode;
  }

  private createScriptProcessorNode(): ScriptProcessorNode {
    this.#noiseSuppressionNode = new NoiseSuppressionScriptProcessor({
      context: this.#context,
      noiseSuppressor: this.#noiseSuppressor,
    });

    return this.#noiseSuppressionNode.noiseSuppressionScriptProcessorNode;
  }
}
